import React from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import { Container, Row, Column, Carousel, ReviewCard, StarRating, Alert } from '@pella/sash-framework';
import { Image, CTA } from '../../../';
import { useReviews } from '../../../../hooks/use-reviews';

const ProductLineRatings = ({ data, ratingCode, className, ...other }) => {
	const configData = useStaticQuery(query).contentstackGlobalConfig?.reviews;
	const { reviews } = useReviews('product', ratingCode);

	if (!data || !ratingCode) return null;

	return (
		<div
			className={`ratings-productLine ${className || ''}`}
			{...other}
		>
			<Container>
				{data.image?.[0] && (
					<Image
						data={data.image[0]}
						className='mb-3 !block w-full xl:mb-6'
					/>
				)}

				<Row verticalGutters>
					<Column
						xs={12}
						md={5}
						xl={4}
					>
						{data.heading && (
							<div
								className='text-lg font-semibold md:text-xl xl:text-28px'
								dangerouslySetInnerHTML={{ __html: data.heading }}
							/>
						)}
						{data.material && (
							<div className='my-4'>
								<span
									className='rounded-full border border-black bg-primary px-4 py-1 text-xs font-semibold capitalize !leading-none xl:text-lg'
									dangerouslySetInnerHTML={{ __html: data.material }}
								/>
							</div>
						)}
						{reviews?.[ratingCode]?.OverallSatisfactionRating && (
							<StarRating
								rating={reviews[ratingCode]?.OverallSatisfactionRating}
								totalReviews={reviews[ratingCode]?.TotalReviews}
							/>
						)}
						{data.cta?.[0] && (
							<div className='mt-6 md:mt-5 xl:mt-12'>
								<CTA data={data.cta[0]} />
							</div>
						)}
					</Column>

					<Column
						xs={12}
						md={7}
						xl={8}
					>
						{reviews?.Empty && (
							<Alert
								type='info'
								hideClose
							>
								{reviews.Empty}
							</Alert>
						)}
						{reviews?.Reviews?.[0] && (
							<Carousel
								slidePadding={10}
								showArrows
							>
								{reviews.Reviews.slice(0, 20).map((review, index) => {
									const date = new Date(review.DateSurveyed);

									return (
										<ReviewCard
											rating={reviews[ratingCode]?.OverallSatisfactionRating}
											date={date?.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
											key={index}
										>
											{review.WhyChosePella && (
												<>
													<ReviewCard.Heading content={configData?.heading_1} />
													<ReviewCard.Content content={review.WhyChosePella} />
												</>
											)}
											{review.MemorableAspects && (
												<>
													<ReviewCard.Heading content={configData?.heading_2} />
													<ReviewCard.Content content={review.MemorableAspects} />
												</>
											)}
											<ReviewCard.Author name={review.CustomerFirstName + ' ' + review.CustomerLastName} />
										</ReviewCard>
									);
								})}
							</Carousel>
						)}
					</Column>
				</Row>
			</Container>
		</div>
	);
};

ProductLineRatings.propTypes = {
	data: PropTypes.object,
	className: PropTypes.string,
	ratingCode: PropTypes.string,
};

export default ProductLineRatings;

export const query = graphql`
	{
		contentstackGlobalConfig {
			reviews {
				heading
				description
				heading_1
				heading_2
			}
		}
	}
`;
